var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 78.9474,
    fill: "#DAEAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0486 70.7833V126.226L99.7908 98.5046V43.062L52.0486 70.7833Z",
    fill: "url(#paint0_linear_349_21012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5106 125.764L99.6368 153.177C99.7908 153.331 100.099 153.331 100.253 153.177L147.379 125.764C147.841 125.456 147.841 124.84 147.379 124.532L100.099 103.125C99.9448 102.971 99.7908 102.971 99.4828 103.125L52.5106 124.532C52.0486 124.84 52.0486 125.456 52.5106 125.764Z",
    fill: "#7FB5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0483 126.226V70.7832L99.7906 98.026V153.947L52.0483 126.226Z",
    fill: "#7FB5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7905 98.5046V43.062L147.533 70.7833V126.226L99.7905 98.5046Z",
    fill: "url(#paint1_linear_349_21012)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7905 98.5045V153.947L147.533 126.226V70.7832L99.7905 98.5045Z",
    fill: "#1760CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5867 69.5513L29.2556 46.2962L77.6139 18.4209L99.9449 41.676V43.6781L51.5867 71.7074V69.5513Z",
    fill: "url(#paint2_linear_349_21012)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2553 46.2964L28.9473 47.0664L51.5863 70.3215V69.5515L29.2553 46.2964Z",
    fill: "#003C8B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9438 41.676L122.121 18.4209L170.633 46.2962L148.302 69.5513V71.3994L99.9438 43.6781V41.676Z",
    fill: "url(#paint3_linear_349_21012)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.634 46.2964L170.942 47.0664L148.303 70.3215V69.5515L170.634 46.2964Z",
    fill: "#003C8B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9445 97.7346L77.9215 100.353L29.7173 72.3234L51.5863 69.5513L99.9445 97.7346Z",
    fill: "url(#paint4_linear_349_21012)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9212 100.353L77.7672 100.969L29.4089 72.9393L29.717 72.3232L77.9212 100.353Z",
    fill: "#074492"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9218 100.353L77.7678 100.969L99.9449 98.1964V97.7344L77.9218 100.353Z",
    fill: "#AFD0FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9438 97.7346L121.967 100.353L170.017 72.3234L148.302 69.5513L99.9438 97.7346Z",
    fill: "url(#paint5_linear_349_21012)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.967 100.353L122.121 100.969L170.325 72.9393L170.017 72.3232L121.967 100.353Z",
    fill: "#003C8B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.967 100.353L122.121 100.969L99.9441 98.1964V97.7344L121.967 100.353Z",
    fill: "#AFD0FE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9005 121.76C57.7465 121.76 57.7465 121.606 57.7465 121.452V114.368C57.7465 114.214 57.9005 114.214 57.9005 114.214L64.0608 117.756C64.2148 117.756 64.2148 117.91 64.2148 118.064V125.148C64.2148 125.302 64.0608 125.302 64.0608 125.302L57.9005 121.76ZM64.0608 117.448L57.9005 113.906C57.5925 113.752 57.4385 113.906 57.4385 114.214V121.298C57.4385 121.606 57.5925 121.914 57.9005 122.068L64.0608 125.61C64.3688 125.764 64.5228 125.61 64.5228 125.302V118.218C64.5228 117.91 64.3688 117.602 64.0608 117.448Z",
    fill: "#7FB5FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6007 126.072C65.4467 126.072 65.4467 125.918 65.4467 125.764V118.68C65.4467 118.526 65.6007 118.526 65.6007 118.526L71.761 122.068C71.915 122.068 71.915 122.222 71.915 122.376V129.46C71.915 129.614 71.761 129.614 71.761 129.614L65.6007 126.072ZM71.761 121.914L65.6007 118.372C65.2927 118.218 65.1387 118.372 65.1387 118.68V125.764C65.1387 126.072 65.2927 126.38 65.6007 126.534L71.761 130.076C72.069 130.23 72.223 130.076 72.223 129.768V122.684C72.223 122.376 71.915 122.068 71.761 121.914Z",
    fill: "#7FB5FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3011 130.539C73.1471 130.539 73.1471 130.385 73.1471 130.231V123.146C73.1471 122.992 73.3011 122.992 73.3011 122.992L79.4614 126.534C79.6154 126.534 79.6154 126.688 79.6154 126.842V133.927C79.6154 134.081 79.4614 134.081 79.4614 134.081L73.3011 130.539ZM79.4614 126.38L73.3011 122.838C72.9931 122.684 72.8391 122.838 72.8391 123.146V130.231C72.8391 130.539 72.9931 130.847 73.3011 131.001L79.4614 134.543C79.7694 134.697 79.9234 134.543 79.9234 134.235V127.15C79.9234 126.842 79.6154 126.534 79.4614 126.38Z",
    fill: "#7FB5FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.058 117.294L61.2879 119.142H62.058L61.904 122.992L59.9019 121.914V118.064L60.6719 118.68L59.7479 116.062L58.9778 117.756L59.7479 117.91L59.5939 121.76L58.3618 120.99V121.298L63.5981 124.224V123.916L62.212 123.146V119.296L62.982 120.066L62.058 117.294Z",
    fill: "#7FB5FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6829 122.222L66.6787 119.912V120.682C66.6787 121.914 67.4487 123.3 68.5268 123.916V126.226C68.0648 126.072 67.7568 126.226 67.7568 126.534L69.6048 127.612C69.6048 127.15 69.2968 126.688 68.8348 126.38V124.07C69.9129 124.532 70.6829 124.07 70.6829 122.838V122.222Z",
    fill: "#7FB5FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5349 125.61L76.2269 125.456V125.764C74.9948 125.148 74.0708 125.764 74.0708 127.15L76.2269 128.382V130.846C76.2269 131 76.0729 131.154 75.9189 131C75.7649 130.846 75.6109 130.692 75.6109 130.538L75.3029 130.384C75.3029 130.692 75.6109 131.154 75.9189 131.308C76.2269 131.462 76.5349 131.308 76.5349 131V128.536L78.691 129.768C78.691 128.382 77.767 126.688 76.5349 125.918V125.61Z",
    fill: "#7FB5FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M134.774 104.665L116.447 115.292V128.69L134.774 118.064V104.665Z",
    fill: "#EDF4FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_349_21012",
    x1: 67.4493,
    y1: 43.062,
    x2: 99.7908,
    y2: 96.1945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1760CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_349_21012",
    x1: 115.191,
    y1: 43.062,
    x2: 147.533,
    y2: 96.1945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1760CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_349_21012",
    x1: 78.4218,
    y1: 27.1322,
    x2: 42.2892,
    y2: 71.0459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#7FB5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_349_21012",
    x1: 149.11,
    y1: 27.0818,
    x2: 113.227,
    y2: 70.9458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#7FB5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_349_21012",
    x1: 64.8309,
    y1: 69.5513,
    x2: 64.8309,
    y2: 100.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3388FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_349_21012",
    x1: 136.283,
    y1: 68.7161,
    x2: 133.737,
    y2: 100.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FB5FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.7335780b.svg";
export { ForwardRef as ReactComponent };